import BaseCollectionService from "./base.collection.service";

class ActivityService extends BaseCollectionService {
  constructor() {
    super("activities");
  }
}

export default new ActivityService();
